import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateJourneyStepTraineeSessionMutationVariables = Types.Exact<{
  input: Types.CreateJourneyStepTraineeSessionInput;
}>;


export type CreateJourneyStepTraineeSessionMutation = { createJourneyStepTraineeSession: { sessionId: string } };


export const CreateJourneyStepTraineeSessionDocument = /*#__PURE__*/ gql`
    mutation createJourneyStepTraineeSession($input: CreateJourneyStepTraineeSessionInput!) {
  createJourneyStepTraineeSession(input: $input) {
    sessionId
  }
}
    `;

export function useCreateJourneyStepTraineeSessionMutation() {
  return Urql.useMutation<CreateJourneyStepTraineeSessionMutation, CreateJourneyStepTraineeSessionMutationVariables>(CreateJourneyStepTraineeSessionDocument);
};